import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { LockIcon } from 'lucide-react';
import { CHECKOUT_URL, PRICE } from '../data/content';
import { goToCheckout } from '../utils/checkout';
export function StickyBuyBar() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 560);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-216" data-mp="3hgwx6gy3rrvn">
      {visible && <motion.div initial={{
      y: 90,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 90,
      opacity: 0
    }} transition={{
      duration: 0.45,
      ease: [0.16, 1, 0.3, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-sand bg-ivory/95 px-4 py-3 backdrop-blur md:hidden" data-id="element-217" data-mp="3veljzubqd93c">
          <div className="flex items-center gap-4" data-id="element-218" data-mp="1w32a9dilrwsm">
            <div className="shrink-0" data-id="element-219" data-mp="29fishvvsrqe8">
              <p className="font-display text-xl font-light leading-none text-ink" data-id="element-220" data-mp="29gkhz5dk8ffh">{PRICE}</p>
              <p className="mt-1 flex items-center gap-1 font-sans text-[0.56rem] uppercase tracking-[0.14em] text-mute" data-id="element-221" data-mp="2eec57m39fddc">
                <LockIcon className="h-2.5 w-2.5 text-gold" aria-hidden="true" data-id="element-222" data-mp="2idl0ivdy7jb0" />
                Pago seguro
              </p>
            </div>
            <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" onClick={event => goToCheckout(event, 'sticky-movil')} className="flex-1 rounded-full bg-ink px-5 py-3.5 text-center font-sans text-[0.66rem] uppercase tracking-luxe text-ivory transition-colors duration-500 hover:bg-gold" data-id="element-223" data-mp="2s60gxo9ljzts">
              Quiero volver a mí
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}